import {useState, useEffect} from 'react';



function useReduceStore(store, storeProvider, fetchAction, deps) {
    //setState is used to trigger useState hook, so it returns most recent data from the storeProvider
    //we do not track the state locally, tracking that can lead to stale state issue
    //and since we are already tracking state in the ReduceStore, we use ReduceStore as the only source of data
    var storeData = storeProvider(store);
    
    const [state, setState] = useState(storeData);
    if(state !== storeData)
        setState(storeData);

    useEffect(() => {
        const storeData = storeProvider(store);

        const listener = store.addListener(() => {
            //this will trigger useState hook causing the UI to re-render with storeProvider data
            setState(storeProvider(store));
        });

        if(!storeData) {
            fetchAction();
        }
        return () => listener.remove();
    }, deps);

    return storeProvider(store);
}

export default useReduceStore;


// WEBPACK FOOTER //
// ./src/hooks/ReduceStoreHook.js